module.exports = __webpack_public_path__ + "static/media/logSensors.4eb1fc89.svg";